export const GET_SANTRI_SUCCEED = "santri/get/succeed";
export const GET_SANTRI_REQUEST = "santri/get/request";
export const GET_SANTRI_FAILED = "santri/get/failed";

export const CREATE_SANTRI_REQUEST = "santri/create/request";
export const CREATE_SANTRI_SUCCEED = "santri/create/succeed";
export const CREATE_SANTRI_FAILED = "santri/create/failed";

export const DELETE_SANTRI_REQUEST = "santri/delete/request";
export const DELETE_SANTRI_SUCCEED = "santri/delete/succeed";
export const DELETE_SANTRI_FAILED = "santri/delete/failed";

export const GET_BY_ID_SANTRI_REQUEST = "santri/getid/request";
export const GET_BY_ID_SANTRI_SUCCEED = "santri/getid/succeed";
export const GET_BY_ID_SANTRI_FAILED = "santri/getid/failed";

export const GET_BY_RUMAHTAHFIDZ_SANTRI_REQUEST =
  "santri/getrumahtahfidz/request";
export const GET_BY_RUMAHTAHFIDZ_SANTRI_SUCCEED =
  "santri/getrumahtahfidz/succeed";
export const GET_BY_RUMAHTAHFIDZ_SANTRI_FAILED =
  "santri/getrumahtahfidz/failed";

export const GET_BY_MASTERTAHFIDZ_SANTRI_REQUEST =
  "santri/getmastertahfidz/request";
export const GET_BY_MASTERTAHFIDZ_SANTRI_SUCCEED =
  "santri/getmastertahfidz/succeed";
export const GET_BY_MASTERTAHFIDZ_SANTRI_FAILED =
  "santri/getmastertahfidz/failed";

export const GET_BY_USER_SANTRI_REQUEST = "santri/getbyusersantri/request";
export const GET_BY_USER_SANTRI_SUCCEED = "santri/getbyusersantri/succeed";
export const GET_BY_USER_SANTRI_FAILED = "santri/getbyusersantri/failed";

export const UPDATE_SANTRI_REQUEST = "santri/update/request";
export const UPDATE_SANTRI_SUCCEED = "santri/update/succeed";
export const UPDATE_SANTRI_FAILED = "santri/update/failed";

export const UPDATE_SANTRI_NOFILE_REQUEST = "santri/updatenofile/request";
export const UPDATE_SANTRI_NOFILE_SUCCEED = "santri/updatenofile/succeed";
export const UPDATE_SANTRI_NOFILE_FAILED = "santri/updatenofile/failed";
